<app-menu-common url="sales"></app-menu-common>

<div class="invoices-container">
  <!-- Page Header & Filters -->
  <div class="pageheader flexcolumn">
    <div class="header-title-row">
      <div class="pagetitle-wrapper">
        <mat-icon class="pagetitle-icon">receipt_long</mat-icon>
        <div>
          <div class="pagetitle grey">Factures Clients</div>
          <div class="pagesubtitle text-muted">Historique des factures émises, encaissements et justificatifs fiscaux</div>
        </div>
      </div>
      <span class="spacer"></span>
      <div class="header-actions">
        <a mat-stroked-button color="primary" routerLink="/sales/bank-lettering" class="action-btn" matTooltip="Ouvrir le lettrage bancaire des ventes">
          <mat-icon>account_balance</mat-icon>
          Rapprochement Bancaire
        </a>
        <button mat-stroked-button color="primary" class="action-btn" (click)="loadInvoices()" [disabled]="isLoading" matTooltip="Rafraîchir les données">
          <mat-icon [class.spinning]="isLoading">refresh</mat-icon>
          Actualiser
        </button>
      </div>
    </div>

    <!-- Filters Row 1: Partner & Dates -->
    <div class="filters-row">
      <div class="filter-item partner-filter">
        <app-search-partner
          [currentPartner]="selectedPartner"
          width="360px"
          [showSelectionInInput]="true"
          (partnerChange)="onPartnerChange($event)">
        </app-search-partner>
      </div>

      <div class="filter-item">
        <app-select-date
          label="Du"
          [date]="filter.dateFrom"
          (dateChange)="onDateChange($event, 'from')">
        </app-select-date>
      </div>

      <div class="filter-item">
        <app-select-date
          label="Au"
          [date]="filter.dateTo"
          (dateChange)="onDateChange($event, 'to')">
        </app-select-date>
      </div>

      <div class="filter-item status-filter">
        <label class="filter-label">Statut règlement</label>
        <select class="custom-select" [(ngModel)]="filter.state" (change)="onSearch()">
          <option value="ALL">Tous les statuts</option>
          <option value="OPEN">🔴 Non réglée</option>
          <option value="PARTIALLY_PAID">🟠 Partiellement réglée</option>
          <option value="PAID">🟢 Soldée</option>
        </select>
      </div>

      <div class="filter-item doctype-filter">
        <label class="filter-label">Type de document</label>
        <select class="custom-select" [(ngModel)]="filter.docType" (change)="onSearch()">
          <option value="ALL">Tous les types</option>
          <option value="FACTURE">Factures de vente</option>
          <option value="FACTURE_ACOMPTE">Factures d'acompte</option>
        </select>
      </div>
    </div>

    <!-- Filters Row 2: Search keyword, Limit & Reset -->
    <div class="filters-row">
      <div class="filter-item search-filter">
        <label class="filter-label">Recherche rapide</label>
        <div class="search-input-wrapper">
          <input
            type="text"
            class="custom-input"
            placeholder="Réf facture, client, commande..."
            [(ngModel)]="filter.search"
            (keyup.enter)="onSearch()" />
          @if (filter.search) {
            <button mat-icon-button (click)="filter.search = ''; onSearch()" class="clear-search-btn">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>

      <div class="filter-item limit-filter">
        <label class="filter-label">Nb réponses</label>
        <select class="custom-select" [(ngModel)]="filter.limit" (change)="onSearch()">
          @for (limit of limitOptions; track limit) {
            <option [value]="limit">{{ limit }}</option>
          }
        </select>
      </div>

      <div class="filter-actions">
        <button mat-flat-button color="primary" (click)="onSearch()" [disabled]="isLoading">
          <mat-icon>search</mat-icon>
          Filtrer
        </button>
        <button mat-stroked-button color="warn" (click)="onResetFilters()" [disabled]="isLoading" matTooltip="Réinitialiser les filtres">
          <mat-icon>clear</mat-icon>
          Réinitialiser
        </button>
      </div>
    </div>
  </div>

  <!-- KPI Summary Cards -->
  <div class="kpi-banner">
    <div class="kpi-card">
      <div class="kpi-icon-wrapper blue">
        <mat-icon>receipt_long</mat-icon>
      </div>
      <div class="kpi-content">
        <div class="kpi-value">{{ invoiceCount }}</div>
        <div class="kpi-label">Factures trouvées</div>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon-wrapper purple">
        <mat-icon>euro</mat-icon>
      </div>
      <div class="kpi-content">
        <div class="kpi-value">{{ totalInvoicedTtc | number:'1.2-2' }} €</div>
        <div class="kpi-label">Total Facturé TTC</div>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon-wrapper green">
        <mat-icon>payments</mat-icon>
      </div>
      <div class="kpi-content">
        <div class="kpi-value success-text">{{ totalPaid | number:'1.2-2' }} €</div>
        <div class="kpi-label">Total Encaissé</div>
      </div>
    </div>

    <div class="kpi-card" [class.highlight-due]="totalDue > 0">
      <div class="kpi-icon-wrapper red">
        <mat-icon>pending_actions</mat-icon>
      </div>
      <div class="kpi-content">
        <div class="kpi-value" [class.due-alert]="totalDue > 0">{{ totalDue | number:'1.2-2' }} €</div>
        <div class="kpi-label">Reste à Recouvrer</div>
        @if (totalTpDue > 0) {
          <div class="kpi-subtext">
            <span>RAC : {{ totalPatientDue | number:'1.2-2' }} €</span>
            <span class="sep">|</span>
            <span>TP : {{ totalTpDue | number:'1.2-2' }} €</span>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading) {
    <div class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Chargement des factures...</span>
    </div>
  }

  <!-- Invoices Table View -->
  @if (!isLoading) {
    <div class="table-card">
      @if (invoices.length > 0) {
        <div class="table-responsive">
          <table class="invoices-table">
            <thead>
              <tr>
                <th class="col-expand"></th>
                <th class="col-docref">Réf. Facture</th>
                <th class="col-date">Date Émission</th>
                <th class="col-customer">Client / Payeur</th>
                <th class="col-origin">Origine</th>
                <th class="col-amount text-right">Total HT</th>
                <th class="col-amount text-right">Total TTC</th>
                <th class="col-amount text-right">Réglé</th>
                <th class="col-amount text-right">Reste Dû</th>
                <th class="col-state text-center">Statut Règlement</th>
                <th class="col-actions text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (invoice of invoices; track trackByInvoice($index, invoice)) {
                <!-- Main Invoice Row -->
                <tr class="invoice-row" [class.row-expanded]="isExpanded(invoice.orderId)">
                  <!-- Expand / Collapse Button -->
                  <td class="col-expand text-center">
                    @if (invoice.receivables && invoice.receivables.length > 0) {
                      <button
                        mat-icon-button
                        class="expand-btn"
                        (click)="toggleExpand(invoice.orderId)"
                        [matTooltip]="isExpanded(invoice.orderId) ? 'Masquer créances' : 'Voir détail créances'">
                        <mat-icon>{{ isExpanded(invoice.orderId) ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </button>
                    }
                  </td>
                  <!-- Document Reference -->
                  <td class="col-docref">
                    <div class="docref-wrapper">
                      @if (isMigrated(invoice)) {
                        <span class="docref-chip docref-migrated" matTooltip="Facture reprise d'orthop : pas de PDF">
                          <span>{{ invoice.docRef }}</span>
                        </span>
                      } @else {
                        <span class="docref-chip" (click)="onViewInvoice(invoice)" matTooltip="Consulter la facture">
                          <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
                          <span>{{ invoice.docRef }}</span>
                        </span>
                      }
                      @if (isDepositInvoice(invoice)) {
                        <span class="badge-acompte" matTooltip="Facture d'acompte (art. 269-2-c du CGI)">
                          Acompte
                        </span>
                      }
                      @if (isFseInvoice(invoice)) {
                        <span class="badge-fse" matTooltip="Facture SESAM-Vitale FSE avec Tiers-Payant">
                          FSE
                        </span>
                      }
                    </div>
                  </td>
                  <!-- Invoice Date -->
                  <td class="col-date">
                    {{ invoice.invoiceDate | date:'dd/MM/yyyy HH:mm' }}
                  </td>
                  <!-- Customer -->
                  <td class="col-customer">
                    <div class="customer-name font-semibold">{{ invoice.customerName }}</div>
                    @if (invoice.addrBillName && invoice.addrBillName !== invoice.customerName) {
                      <div class="billing-name text-muted">
                        Facturé à : {{ invoice.addrBillName }}
                      </div>
                    }
                  </td>
                  <!-- Origin: Order ID & Delivery ID -->
                  <td class="col-origin">
                    <div class="origin-links">
                      @if (invoice.parentOrderId) {
                        <a [routerLink]="['/sales/quotation', invoice.parentOrderId]" class="link-order" matTooltip="Ouvrir la commande principale #{{ invoice.parentOrderId }}">
                          Cde #{{ invoice.parentOrderId }}
                        </a>
                        <span class="badge-acompte-origin" matTooltip="Commande d'acompte #{{ invoice.orderId }}">
                          (Acompte)
                        </span>
                      } @else {
                        <a [routerLink]="['/sales/quotation', invoice.orderId]" class="link-order" matTooltip="Ouvrir la commande">
                          Cde #{{ invoice.orderId }}
                        </a>
                      }
                      @if (invoice.deliveryId) {
                        <span class="badge-delivery" matTooltip="Bon de livraison associé">
                          BL #{{ invoice.deliveryId }}
                        </span>
                      }
                    </div>
                  </td>
                  <!-- Pre-Tax HT Amount -->
                  <td class="col-amount text-right">
                    {{ invoice.amountTaxx | number:'1.2-2' }} €
                  </td>
                  <!-- TTC Amount -->
                  <td class="col-amount text-right font-semibold">
                    <div>{{ invoice.amountTaxi | number:'1.2-2' }} €</div>
                    @if (hasThirdParty(invoice)) {
                      <div class="split-breakdown">
                        <span class="split-rac" matTooltip="Part Patient (Reste à charge)">RAC {{ getPatientExpected(invoice) | number:'1.2-2' }} €</span>
                        <span class="split-sep">|</span>
                        <span class="split-tp" matTooltip="Prise en charge Tiers-Payant (AMO/AMC)">TP {{ getTpExpected(invoice) | number:'1.2-2' }} €</span>
                      </div>
                    }
                  </td>
                  <!-- Amount Paid -->
                  <td class="col-amount text-right success-text">
                    <div>{{ invoice.amountPaid | number:'1.2-2' }} €</div>
                    @if (hasThirdParty(invoice)) {
                      <div class="split-breakdown">
                        <span class="split-rac" matTooltip="Réglé par le patient">RAC {{ getPatientPaid(invoice) | number:'1.2-2' }} €</span>
                        <span class="split-sep">|</span>
                        <span class="split-tp" matTooltip="Réglé par les caisses (RSP)">TP {{ getTpPaid(invoice) | number:'1.2-2' }} €</span>
                      </div>
                    }
                  </td>
                  <!-- Amount Due -->
                  <td class="col-amount text-right" [class.due-alert]="invoice.amountDue > 0">
                    <div>{{ invoice.amountDue | number:'1.2-2' }} €</div>
                    @if (hasThirdParty(invoice)) {
                      <div class="split-breakdown">
                        <span [class.rac-due-alert]="getPatientDue(invoice) > 0" matTooltip="Reste à charge patient restant dû">
                          RAC {{ getPatientDue(invoice) | number:'1.2-2' }} €
                        </span>
                        <span class="split-sep">|</span>
                        <span [class.tp-due-alert]="getTpDue(invoice) > 0" matTooltip="Tiers-payant restant dû">
                          TP {{ getTpDue(invoice) | number:'1.2-2' }} €
                        </span>
                      </div>
                    }
                  </td>
                  <!-- Payment State Badge -->
                  <td class="col-state text-center">
                    <span class="status-badge" [ngClass]="getInvoicePaymentStateBadge(invoice).cssClass">
                      <mat-icon class="badge-icon">{{ getInvoicePaymentStateBadge(invoice).icon }}</mat-icon>
                      {{ getInvoicePaymentStateBadge(invoice).label }}
                    </span>
                  </td>
                  <!-- Action Buttons -->
                  <td class="col-actions text-center">
                    <div class="actions-wrapper">
                      <a
                        mat-icon-button
                        [routerLink]="['/sales/quotation', invoice.orderId]"
                        matTooltip="Consulter la commande">
                        <mat-icon>visibility</mat-icon>
                      </a>
                    </div>
                  </td>
                </tr>
                <!-- Expanded Receivables Drawer -->
                @if (isExpanded(invoice.orderId)) {
                  <tr class="receivables-drawer-row">
                    <td colspan="11" class="receivables-drawer-cell">
                      <div class="receivables-drawer-content">
                        <div class="drawer-header">
                          <mat-icon>account_tree</mat-icon>
                          <span>Détail de la répartition des créances (Tiers Payeurs) :</span>
                        </div>
                        <table class="receivables-subtable">
                          <thead>
                            <tr>
                              <th>Tiers Payeur</th>
                              <th class="text-right">Montant Attendu</th>
                              <th class="text-right">Montant Réglé</th>
                              <th class="text-right">Reste Dû</th>
                              <th class="text-center">Statut Créance</th>
                              <th class="text-center">Échéance</th>
                              <th class="text-center">Règlements & Délettrage</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (rec of invoice.receivables; track trackByReceivable($index, rec)) {
                              <tr>
                                <td>
                                  @if (rec.payerType) {
                                    <span class="badge-payer" [ngClass]="getPayerTypeBadgeClass(rec.payerType)">
                                      {{ rec.payerType }}
                                    </span>
                                  }
                                  <span class="payer-name font-semibold">{{ rec.payerName || 'Client' }}</span>
                                  <span class="payer-id text-muted"> (ID: {{ rec.payerId }})</span>
                                </td>
                                <td class="text-right">{{ rec.amountExpected | number:'1.2-2' }} €</td>
                                <td class="text-right success-text">{{ rec.amountPaid | number:'1.2-2' }} €</td>
                                <td class="text-right" [class.due-alert]="rec.amountDue > 0">
                                  <span>{{ rec.amountDue | number:'1.2-2' }} €</span>
                                </td>
                                <td class="text-center">
                                  <span class="status-badge small" [ngClass]="getReceivableStateClass(rec.state)">
                                    {{ rec.state === 'PAID' ? 'Soldée' : (rec.state === 'PARTIALLY_PAID' ? 'Partielle' : 'Ouverte') }}
                                  </span>
                                </td>
                                <td class="text-center text-muted">
                                  {{ rec.dueDate ? (rec.dueDate | date:'dd/MM/yyyy') : '-' }}
                                </td>
                                <td class="text-center">
                                  @if (rec.amountPaid > 0) {
                                    <button
                                      mat-stroked-button
                                      class="allocations-toggle-btn"
                                      [class.active]="isReceivableAllocationsExpanded(rec.id)"
                                      (click)="toggleReceivableAllocations(rec)"
                                      [matTooltip]="isReceivableAllocationsExpanded(rec.id) ? 'Masquer les imputations' : 'Consulter les imputations et délettrer'">
                                      <mat-icon>{{ isReceivableAllocationsExpanded(rec.id) ? 'expand_less' : 'receipt_long' }}</mat-icon>
                                      <span>{{ isReceivableAllocationsExpanded(rec.id) ? 'Fermer' : 'Règlements' }}</span>
                                    </button>
                                  } @else {
                                    <span class="text-muted italic text-xs">-</span>
                                  }
                                </td>
                              </tr>
                              <!-- Nested Allocations Row for Delettering -->
                              @if (isReceivableAllocationsExpanded(rec.id)) {
                                <tr class="allocations-drawer-row">
                                  <td colspan="7" class="allocations-drawer-cell">
                                    <div class="allocations-drawer-content">
                                      <div class="allocations-header">
                                        <mat-icon>account_balance</mat-icon>
                                        <span class="font-semibold">Règlements actifs imputés sur la créance #{{ rec.id }} :</span>
                                      </div>

                                      @if (isLoadingAllocations(rec.id)) {
                                        <div class="allocations-loading">
                                          <mat-spinner diameter="20"></mat-spinner>
                                          <span>Chargement des imputations...</span>
                                        </div>
                                      } @else {
                                        @if ((getReceivableAllocationsList(rec.id) || []).length > 0) {
                                          <table class="allocations-subtable">
                                            <thead>
                                              <tr>
                                                <th>Date Encaissement</th>
                                                <th>Mode de règlement</th>
                                                <th>Réf. Bancaire</th>
                                                <th>Note</th>
                                                <th class="text-right">Montant Imputé</th>
                                                <th class="text-center">Action BOFIP</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              @for (alloc of getReceivableAllocationsList(rec.id); track alloc.payment_id) {
                                                <tr>
                                                  <td>{{ alloc.payment_date ? (alloc.payment_date | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
                                                  <td>
                                                    <span class="badge-payment-method">{{ getPaymentMethodName(alloc.payment_method) }}</span>
                                                  </td>
                                                  <td>{{ alloc.bank_reference || '-' }}</td>
                                                  <td class="text-muted">{{ alloc.note || '-' }}</td>
                                                  <td class="text-right font-semibold success-text">{{ alloc.allocated_amount | number:'1.2-2' }} €</td>
                                                  <td class="text-center">
                                                    <button
                                                      mat-stroked-button
                                                      color="warn"
                                                      class="deletter-action-btn"
                                                      (click)="onDeletterAllocation(invoice, rec, alloc)"
                                                      matTooltip="Contre-passer cette imputation (Délettrage inaltérable BOFIP ISCA)">
                                                      <mat-icon>link_off</mat-icon>
                                                      <span>Délettrer</span>
                                                    </button>
                                                  </td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                        } @else {
                                          <div class="allocations-empty text-muted">
                                            Aucun règlement actif sur cette créance.
                                          </div>
                                        }
                                      }
                                    </div>
                                  </td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="empty-state">
          <mat-icon class="empty-icon">search_off</mat-icon>
          <div class="empty-title">Aucune facture trouvée</div>
          <div class="empty-subtitle">
            Aucune facture ne correspond aux critères de recherche actuels.
          </div>
          <button mat-stroked-button color="primary" (click)="onResetFilters()">
            Réinitialiser les filtres
          </button>
        </div>
      }
      <!-- Empty State -->
    </div>
  }
</div>
